import { Link } from "react-router";

export default function NotFoundPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-surface-base">
      <div className="max-w-md space-y-4 text-center">
        <div className="text-display-lg font-semibold text-ink">404</div>
        <p className="text-body text-ink-muted">The page you're looking for doesn't exist.</p>
        <Link
          to="/"
          className="inline-block rounded-pill bg-brand-500 px-6 py-2 text-body font-medium text-white transition-colors hover:bg-brand-600 focus:outline-none focus:shadow-focus"
        >
          Go home
        </Link>
      </div>
    </div>
  );
}
